import React from 'react';
import { NotificationManager } from 'react-notifications';

function NotificationItem({ notification }) {
  React.useEffect(() => {
    if (notification.timeOut === 0) return undefined;
    const timer = window.setTimeout(
      () => NotificationManager.remove(notification),
      notification.timeOut || 5000,
    );
    return () => window.clearTimeout(timer);
  }, [notification]);

  const handleClick = () => {
    if (typeof notification.onClick === 'function') notification.onClick();
    NotificationManager.remove(notification);
  };

  return (
    <button
      type="button"
      className={`notification notification-${notification.type || 'info'} ae-notification`}
      onClick={handleClick}
    >
      <div className="notification-message" role="alert">
        {notification.title ? <h4 className="title">{notification.title}</h4> : null}
        <div className="message">{notification.message}</div>
      </div>
    </button>
  );
}

export default function NotificationContainer() {
  const [notifications, setNotifications] = React.useState(
    () => [...NotificationManager.listNotify],
  );

  React.useEffect(() => {
    const handleChange = (nextNotifications) => {
      setNotifications([...nextNotifications]);
    };
    NotificationManager.addChangeListener(handleChange);
    return () => NotificationManager.removeChangeListener(handleChange);
  }, []);

  return (
    <div className={`notification-container${notifications.length === 0 ? ' notification-container-empty' : ''}`}>
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </div>
  );
}
